function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { PureComponent } from "react";
import { StyledAssetContentCard } from "./asset-content-card-component.scss";
import DefaultProps from "./default-props";
import AssetComponent from "/components/core/asset/asset-component";
import PillComponent from "/components/core/pill/pill-component";
import Button from "segments/desktop/core-components/button/button";
class AssetContentCardComponent extends PureComponent {
    render() {
        const { asset, title, titleFontSize, titleFontWeight, minWidth, maxWidth, borderRadius, borderThickness, borderColor, cardPadding, contentPadding, assetBottomMargin, titleBottomMargin, contentType, buttonPadding, buttonConfig, dividerConfig } = this.props;
        function renderContentType(contentType) {
            if (contentType) {
                const { type } = contentType;
                switch(type){
                    case "Pills":
                        const pills = contentType.pills;
                        return /*#__PURE__*/ _jsxs("div", {
                            className: "pills-container",
                            children: [
                                /*#__PURE__*/ _jsx("div", {
                                    className: "pills-wrapper",
                                    children: pills === null || pills === void 0 ? void 0 : pills.map((pill, index)=>/*#__PURE__*/ _jsx(PillComponent, _object_spread({}, pill), index))
                                }),
                                (buttonConfig === null || buttonConfig === void 0 ? void 0 : buttonConfig.buttonType) && /*#__PURE__*/ _jsx("div", {
                                    className: "hover-button-wrapper",
                                    children: /*#__PURE__*/ _jsx(Button, _object_spread({}, buttonConfig))
                                })
                            ]
                        });
                    default:
                        return null;
                }
            }
        }
        return /*#__PURE__*/ _jsxs(StyledAssetContentCard, {
            className: "asset-content-card-component",
            borderRadius: borderRadius,
            borderThickness: borderThickness,
            borderColor: borderColor,
            cardPadding: cardPadding,
            titleFontSize: titleFontSize,
            titleFontWeight: titleFontWeight,
            contentPadding: contentPadding,
            assetBottomMargin: assetBottomMargin,
            titleBottomMargin: titleBottomMargin,
            minWidth: minWidth,
            maxWidth: maxWidth,
            buttonPadding: buttonPadding,
            dividerConfig: dividerConfig,
            children: [
                /*#__PURE__*/ _jsx("div", {
                    className: "asset-wrapper",
                    children: /*#__PURE__*/ _jsx(AssetComponent, _object_spread({}, asset))
                }),
                /*#__PURE__*/ _jsxs("div", {
                    className: "content-wrapper",
                    children: [
                        title && /*#__PURE__*/ _jsx("div", {
                            className: "title-wrapper",
                            children: title
                        }),
                        contentType && /*#__PURE__*/ _jsx("div", {
                            className: "content-type-wrapper",
                            children: renderContentType(contentType)
                        })
                    ]
                })
            ]
        });
    }
}
export { AssetContentCardComponent as default };
AssetContentCardComponent.defaultProps = DefaultProps;
